import React from "react";
import Home from "./Home";
import Dashboard from "./Dashboard";
import { NavLink } from "react-router-dom";
// import DashboardJs from "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha2/dist/js/bootstrap.bundle.min.js";
import logo from './images/logo.svg';
import './font-awesome.min.css';
// import './bootstrap.min.css';
import './style.css';
import { Switch, Route, Redirect } from "react-router-dom";
import bootstrap from "bootstrap";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import 'bootstrap/dist/css/bootstrap.min.css';



function App() {
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  return (
    <div id="wrapper">
        <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/Dashboard" component={Dashboard} />
            {/* <Route exact path="/dashboard" render={(props) => (<Dashboard {...props} isLoggedIn={isLoggedIn} />  )}/> */}
            <Redirect to="/" />
        </Switch>
    </div>
  );
}

export default App;
